module.exports = __webpack_public_path__ + "static/media/pine.dd8899e6.svg";